import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { TariffRateService } from 'src/app/features/setting/service/tariff-rate.service';
import { Injector } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { getForwarderByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserType } from 'src/app/core/enums/user-type.enum';

@Component({
  selector: 'laas-tariff-rate-setting-add',
  templateUrl: './tariff-rate-setting-add.component.html',
  styleUrls: ['./tariff-rate-setting-add.component.scss']
})
export class TariffRateSettingAddComponent extends SessionBaseComponent implements OnInit {

  readonly permissionCode: PermissionConstants = PermissionConstants.ViewTariffRateSetting;

  isSearchFormOpen: boolean;

  //form
  addForm: FormGroup;
  tariffRate: any;
  submitted: boolean;

  //options
  forwarderOptions: any[];

  constructor(
    injector: Injector,
    private fb: FormBuilder,
    private dropdownOptionsService: DropdownOptionsService,
    private tariffRateService: TariffRateService
  ) {
    super(injector);
    this.isSearchFormOpen = true;
    this.submitted = false;

    //options
    this.forwarderOptions = [];

    this.tariffRate = {
      forwarder: '',
      sku: '',
      tariffRate: null,
      customsTariff: '',
      skuDescription: '',
      declarationDtTimeZone: '',
      brand: '',
      isActivated: '1',
      startDtTimeZone: '',
      endDtTimeZone: '',
      createUser: '',
      createDt: '',
      updateUser: '',
      updateDt: ''
    };

    this.addForm = this.fb.group({
      forwarder: '',
      sku: ['', Validators.required],
      tariffRate: [null, Validators.required],
      customsTariff: ['', Validators.required],
      skuDescription: '',
      declarationDtTimeZone: ['', Validators.required],
      brand: ['', Validators.required],
      isActivated: '1',
      startDtTimeZone: ['', Validators.required],
      endDtTimeZone: '',
      createUser: '',
      createDt: '',
      updateUser: '',
      updateDt: ''
    });
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.dropdownOptionsService.getForwarderOptions().subscribe({
      next: (options: any[]) => {
        this.forwarderOptions = options.filter((x: any) => {
          return (this.userProfile.userType === UserType.SuperAdmin.toString() ||
            this.userProfile.userType === UserType.Shipping.toString() ||
            getForwarderByPermission(this.userProfile, this.permissionCode).includes(x.optionCode));
        }).map(x => ({ label: x.optionDesc, value: x.optionCode }));
        this.translateService.get('Common.Message.ChooseOption')
          .subscribe({
            next: msg => {
              this.forwarderOptions.unshift({
                label: msg,
                value: ''
              });
            }
          });

      }
    });

    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }
  }

  saveBtn(event: any): void {
    this.submitted = true;

    if (this.addForm.invalid) {
      this.translateService.get('TariffRateSetting.Alert.CheckRequiredFields')
        .subscribe({
          next: msg => {
            this.toastService.warn(msg);
          }
        });
      return;
    }

    //DateTime convert
    this.tariffRate.declarationDt = isNullOrEmpty(this.tariffRate.declarationDtTimeZone) ? null : new Date(this.tariffRate.declarationDtTimeZone).toISOString();
    this.tariffRate.startDt = isNullOrEmpty(this.tariffRate.startDtTimeZone) ? null : new Date(this.tariffRate.startDtTimeZone).toISOString();
    this.tariffRate.endDt = isNullOrEmpty(this.tariffRate.endDtTimeZone) ? null : new Date(this.tariffRate.endDtTimeZone).toISOString();
    this.tariffRate.updateUser = this.userProfile.userName;
    this.tariffRate.createUser = this.userProfile.userName;
    this.tariffRate.facility = this.laasSetting.facility;

    this.tariffRateService.addTariffRate(this.tariffRate).subscribe({
      next: result => {
        this.translateService.get('Common.Message.SuccessSave')
          .subscribe({
            next: msg => {
              this.toastService.success(msg);
              this.routeStateService.navigateTo('/Setting/TariffRateSetting', result);
            }
          });
      },
      error: err => {
        console.log(err);
        this.toastErrorMessage(err.error);
      }
    });
  }

  goToLastPage(): void {
    this.routeStateService.loadPrevious();
  }

  // convenience getter for easy access to form fields
  get f() { return this.addForm.controls; }
}
